import styled from "@emotion/styled";
import { PureComponent } from "react";

import { Loader, LoaderSize } from "components/loader";
import { TicketsRoutes } from "constants/tickets/TicketsRoutes";
import { TicketsBatchAction } from "constants/tickets/batch-action";
import { Column } from "constants/tickets/columns";
import { getColumns } from "helpers/tickets";
import { IWithBreakpointsProps, withBreakpoints } from "helpers/withBreakpoints";
import { IAgent } from "store/entities/agents";
import { ITeam } from "store/entities/teams";
import { ITicketsViewBatchUpdatePayloadData } from "store/views/tickets/interfaces";

import { TicketLabel } from "./TicketLabel";
import BulkActions from "./bulk-actions/BulkActions";
import { Th } from "./tickets-styles";

interface IProps extends IWithBreakpointsProps {
  route: TicketsRoutes;
  agents: IAgent[];
  teams: ITeam[];
  isBatchUpdating?: boolean;
  isAnyCheckboxChecked: boolean;
  onSpamModalRequest(type: "spam" | "unspam", selectedIds: string[]): void;
  onBatchActionChosen(action: TicketsBatchAction, data?: ITicketsViewBatchUpdatePayloadData): void;
}

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LoaderMessage = styled.span`
  margin-left: 10px;
  font-size: 13px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

class TicketsListHeader extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { route, isBatchUpdating, isAnyCheckboxChecked, isMobile, onSpamModalRequest } = this.props;

    if (!isAnyCheckboxChecked) {
      return getColumns(isMobile, route).map((column: Column) => <TicketLabel key={column} column={column} />);
    }

    if (isBatchUpdating) {
      return (
        <Th hasLoader>
          <LoaderWrapper>
            <Loader size={LoaderSize.Small} inline />
            <LoaderMessage>Updating…</LoaderMessage>
          </LoaderWrapper>
        </Th>
      );
    }

    return <BulkActions colSpan={getColumns(isMobile).length} onSpamModalRequest={onSpamModalRequest} />;
  }
}

export default withBreakpoints(TicketsListHeader);
